module.exports = __webpack_public_path__ + "img/ES-M-13.f88ec195.svg";